import { REQUEST } from '@/constants/api';

import { AccountTypeDetails } from '@/types/api/account';

import { axios } from './axios';

export const getAccountTypes = async () => {
  const result = await axios.get<AccountTypeDetails[]>(REQUEST.ACCOUNT.TYPES);

  return result.data;
};

export const batchSetAccountTypes = async (accountTypeIds: string[]) => {
  const result = await axios.post(REQUEST.ACCOUNT.TYPES_BATCH, {
    accountTypeIds,
  });

  return result.data;
};
